import React from "react";

const EditMessageModal = ({
  open,
  editedText,
  setEditedText,
  onCancel,
  onSubmit,
  loading = false,
}) => {
  if (!open) return null;

  return (
    <div className="sq-modal-overlay">
      <div className="sq-edit-modal">
        <h3 className="sq-edit-title">Mesajınızı düzəldin</h3>

        <textarea
          className="sq-edit-input"
          value={editedText}
          maxLength={2000}
          onChange={(e) => setEditedText(e.target.value)}
          autoFocus
          rows={5}
        />

        <div className="sq-edit-actions">
          <button type="button" className="sq-cancel-btn" onClick={onCancel}>
            Ləğv et
          </button>
          <button
            type="button"
            className="sq-update-btn"
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? "Düzəldilir..." : "Düzəlt"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditMessageModal;